import { useEffect } from 'react';
import dynamic from 'next/dynamic';

import { EventActions } from '../../analytics/uiMetrics';
import useAnalyticEvent, { PageName } from '../../hooks/useAnalyticEvent';
import useWindowLoaded from '../../hooks/useWindowLoaded';
import { useGetExperimentBucket } from '../../experiments/useIsInExperiment';
import { stcCvtMarketingDynamic } from '../../experiments/experiments';
import { Body, Container } from './Marketing.styles';

const SummaryTiles = dynamic(() => import('./SummaryTiles'));
const HowItWorks = dynamic(() => import('./HowItWorks'));
const Hero = dynamic(() => import('./Hero'));
const GetValueModule = dynamic(() => import('./GetValueModule'));
const KeyValue = dynamic(() => import('./KeyValue'));
const TakeControl = dynamic(() => import('./TakeControl'));
const FAQSection = dynamic(() => import('./FAQ/FAQ'));

const Marketing = () => {
  const isLoaded = useWindowLoaded();
  const { recordGenericEvent } = useAnalyticEvent();

  const dynamicHeaderBucket = useGetExperimentBucket(stcCvtMarketingDynamic);

  useEffect(() => {
    recordGenericEvent(PageName.Marketing, 'Marketing Page', EventActions.Visited);
  }, []);

  return (
    <Container>
      {isLoaded && <SummaryTiles />}
      <Hero dynamicHeaderBucket={dynamicHeaderBucket} />
      <Body>
        <KeyValue />
        <HowItWorks />
        <TakeControl />
        <GetValueModule />
      </Body>
      <FAQSection />
    </Container>
  );
};

export default Marketing;
